import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage, FormattedNumber } from 'components/shared/Intl';
import { FixedUnitReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryFixedUnitFieldProps {
  node: FixedUnitReadonlyValueDefinition;
}

export const ValueWithUnit: FC<{ value: number; unit: string }> = ({ value, unit }) => (
  <>
    <FormattedNumber maximumFractionDigits={4} value={value} unit={unit} />
    {unit && (
      <>
        {' '}
        <FormattedMessage id={`form.${unit}` as any} defaultMessage={`${unit}`} />
      </>
    )}
  </>
);

export const ProductSummaryFixedUnitField: FC<ProductSummaryFixedUnitFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);
  const translationKey = node.translationKey ?? node.id;
  const isHighlighted = node.isHighlighted ?? false;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p
        className={classNames('text-large m-0', {
          'fw-light': !isHighlighted,
          'fw-bold': isHighlighted,
          'text-danger': isHighlighted,
        })}
        data-e2e={`product-summary-field-${node.id}`}
      >
        {isDefined(data) && isDefined(node.unit) ? <ValueWithUnit value={data} unit={node.unit} /> : '_'}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryFixedUnitField.displayName = 'ProductSummaryFixedUnitField';
